import { render, staticRenderFns } from "./RuntimeContent.vue?vue&type=template&id=c7076130&"
import script from "./RuntimeContent.vue?vue&type=script&lang=js&"
export * from "./RuntimeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports